
































































































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { UserDto } from "@/store/users/user.interface";
import ConfirmModal from "@/components/modal/Confirm.vue";

@Component
export default class AppUserForm extends Vue {
  @Prop() data: UserDto;
  @Prop({ default: false }) loading: boolean;
  @Prop({ default: false }) disabled: boolean;

  form: any = {};

  @Emit("onSubmit")
  async onSubmit() {
    return this.form;
  }

  @Emit("onCancel")
  async onCancel() {}

  @Emit("onEditable")
  async onEditable() {}

  reset() {
    this.form = {
      name: "",
      password: "",
      confirm_password: "",
      username: ""
    };
  }

  @Watch("data", { immediate: true, deep: true })
  onDataChange(data: UserDto, oldData: UserDto) {
    this.form = data || {};
  }

  async onRemove() {
    return (this.$refs.confirmModal as ConfirmModal).open();
  }

  @Emit("onRemove")
  async onConfirmRemove() {
    return true;
  }
}
